<div class="content dashboard">
  <app-bar-chart></app-bar-chart>
  @if (authService.hasPermission(Permission.ProductsWorkflowFilter)) {
    <app-shoots-latest></app-shoots-latest>
  }
  @if (authService.hasPermission(Permission.ProductsWorkflowFilter)) {
    <app-post-production-latest></app-post-production-latest>
  }
  @if (authService.hasPermission(Permission.ProductsWorkflowFilter)) {
    <app-post-production-reviewed-latest></app-post-production-reviewed-latest>
  }
  <app-output-collections-latest></app-output-collections-latest>
</div>
